import React, { useEffect } from 'react'
import { Col, Row } from 'reactstrap'
import styled from 'styled-components'
import FormFeedbackAndRating from './FormFeedbackAndRating/FormFeedbackAndRating'
import { FeedbackAndRating } from './FeedbackAndRating'
import { ListTags } from './ListTagsQuestion'
import { ResultFreeText } from './ResultFreeText'
import { useParams } from 'react-router-dom'

const WrapTagsAndFeedback = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  hr {
    margin: 0;
  }
`

export default function TabQuestionInformation(props) {
  const { isShowReview, isShowFeedback, loadingShowForm, setLoadingShowForm, getLoadDataDetail } = props
  let { idFreeText } = useParams();

  useEffect(() => {
    if (idFreeText) {
      getLoadDataDetail(idFreeText)
    } else {
      setLoadingShowForm(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idFreeText])

  return (
    <Row>
      {loadingShowForm && (
        <>
          <Col md={8}>
            <ResultFreeText {...props}/>
          </Col>
          <Col md={4}>
            <WrapTagsAndFeedback>
              <ListTags
                {...props}
              />
              <hr />
              {isShowReview && <FeedbackAndRating {...props}/>}
              {isShowFeedback && <FormFeedbackAndRating {...props}/>}
            </WrapTagsAndFeedback>
          </Col>
        </>
      )}
    </Row>
  )
}
